var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 8.99967C5.88675 8.99967 4.16675 7.27967 4.16675 5.16634C4.16675 3.05301 5.88675 1.33301 8.00008 1.33301C10.1134 1.33301 11.8334 3.05301 11.8334 5.16634C11.8334 7.27967 10.1134 8.99967 8.00008 8.99967ZM8.00008 2.33301C6.44008 2.33301 5.16675 3.60634 5.16675 5.16634C5.16675 6.72634 6.44008 7.99967 8.00008 7.99967C9.56008 7.99967 10.8334 6.72634 10.8334 5.16634C10.8334 3.60634 9.56008 2.33301 8.00008 2.33301Z",
    fill: "#5A5A5A",
    stroke: "#5A5A5A",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7267 15.6667C13.4534 15.6667 13.2267 15.44 13.2267 15.1667C13.2267 12.8667 10.8801 11 8.00013 11C5.1201 11 2.77344 12.8667 2.77344 15.1667C2.77344 15.44 2.54677 15.6667 2.27344 15.6667C2.0001 15.6667 1.77344 15.44 1.77344 15.1667C1.77344 12.32 4.56676 10 8.00013 10C11.4335 10 14.2267 12.32 14.2267 15.1667C14.2267 15.44 14.0001 15.6667 13.7267 15.6667Z",
    fill: "#5A5A5A",
    stroke: "#5A5A5A",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.6dd78a32842387d1edb0e6cebff59be2.svg";
export { ForwardRef as ReactComponent };